export default __webpack_public_path__ + "static/media/hand.9952bc1b.svg";